import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
export function ChatWidget() {
  const [open, setOpen] = useState(false);
  return <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3" data-id="element-135" data-mp="34vl5d8qupaku">
      {/* Chat panel (prototype) */}
      {open && <div role="dialog" aria-label="Live chat help" className="w-72 sm:w-80 rounded-xl bg-white shadow-2xl border border-slate-200 overflow-hidden" data-id="element-136" data-mp="3er4yjne15v5w">
          <div className="px-4 py-3 flex items-center justify-between" style={{
        backgroundColor: '#4A2D8F'
      }} data-id="element-137" data-mp="3nsmactkenaos">
            <div className="flex items-center gap-2 text-white" data-id="element-138" data-mp="6dxrjdq5h99p">
              <MessageCircle className="h-4 w-4" data-id="element-139" data-mp="1e2vkvripths" />
              <span className="text-sm font-bold" data-id="element-140" data-mp="fcj50ugrly3m">Chat with Support</span>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Close chat" className="text-white/80 hover:text-white" data-id="element-141" data-mp="fa6rcti1i9wd">
              <X className="h-4 w-4" data-id="element-142" data-mp="127ko1t2fy99s" />
            </button>
          </div>
          <div className="p-4 space-y-3" data-id="element-143" data-mp="175m8ahblsemu">
            <div className="rounded-lg bg-slate-50 border border-slate-100 p-3 text-xs text-slate-600 leading-relaxed" data-id="element-144" data-mp="176nv1j1zepke">
              Hi! How can we help? For immediate class support, call or text{' '}
              <span className="font-semibold text-slate-800" data-id="element-145" data-mp="1h0o05kx9jut4">602-377-6207</span>
              .
            </div>
            <div className="flex items-center gap-2" data-id="element-146" data-mp="1q3fb7jm88ok8">
              <input type="text" placeholder="Type your message..." className="flex-1 h-9 rounded-md border border-slate-300 px-3 text-xs focus:outline-none focus:ring-2 focus:ring-purple-300" data-id="element-147" data-mp="1q245he9816qh" />
              <button aria-label="Send message" className="flex items-center justify-center h-9 w-9 rounded-md text-white hover:opacity-90" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-148" data-mp="24t4pmgjbyp2g">
                <Send className="h-4 w-4" data-id="element-149" data-mp="4qc0fjy4qc96" />
              </button>
            </div>
          </div>
        </div>}

      {/* Floating chat button */}
      <button onClick={() => setOpen(v => !v)} aria-label={open ? 'Close chat' : 'Open chat help'} aria-expanded={open} className="flex items-center justify-center h-14 w-14 rounded-full text-white shadow-lg hover:opacity-90 transition-opacity focus:outline-none focus:ring-4 focus:ring-purple-300" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-150" data-mp="ijbc1ausjmbg">
        {open ? <X className="h-6 w-6" data-id="element-151" data-mp="11e9vooy50hh0" /> : <MessageCircle className="h-6 w-6" data-id="element-152" data-mp="xg2ejszrhe5a" />}
      </button>
    </div>;
}